
import { useState, useEffect } from 'react';
import { Moon, Sun } from 'lucide-react';
import { Toggle } from '@/components/ui/toggle';

type Theme = 'dark' | 'light';

const ThemeSwitcher = () => {
  const [theme, setTheme] = useState<Theme>('dark');

  // Initialize theme from local storage or use dark as default
  useEffect(() => {
    const storedTheme = localStorage.getItem('theme') as Theme | null;
    if (storedTheme) {
      setTheme(storedTheme);
      document.documentElement.classList.toggle('light-mode', storedTheme === 'light');
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.classList.toggle('light-mode', newTheme === 'light');
  };

  return (
    <Toggle 
      aria-label="Toggle theme"
      pressed={theme === 'light'}
      onPressedChange={toggleTheme}
      className="hover:bg-transparent hover:text-primary/80 p-2"
    >
      {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
      <span className="sr-only">{theme === 'dark' ? 'Light mode' : 'Dark mode'}</span>
    </Toggle>
  );
};

export default ThemeSwitcher;
